(() => {
  const configNode = document.getElementById('vv-case-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const main = document.querySelector('main');
  const currentId = String(config.productId);
  const requestedType = new URL(location.href).searchParams.get('vv_type');
  let chosenType = ['Standart', 'MagSafe'].includes(requestedType) ? requestedType : null;
  let state = 'pending';
  let timer;
  let colorRevision = 0;
  const products = new Map();
  const picker = () => main?.querySelector(`variant-picker[data-product-id="${currentId}"]`);
  const typeInputs = () => [...(picker()?.querySelectorAll('[data-vv-case-type]') || [])];
  const letter = () => {
    if (config.letterIndex < 0) return null;
    const field = picker()?.querySelector('[name="options[Harf]"], input[name^="Harf-"]:checked');
    return field?.value || config.variants[0]?.options?.[config.letterIndex];
  };
  const desiredVariant = () => config.variants.find((variant) => {
    const options = variant.options || [variant.option1, variant.option2, variant.option3];
    return (config.typeIndex < 0 || options[config.typeIndex] === chosenType) &&
      (config.letterIndex < 0 || options[config.letterIndex] === letter());
  });
  function setState(value) {
    state = value;
    document.documentElement.dataset.vvCaseState = value;
    main?.querySelectorAll('[data-vv-price]').forEach((price) => { price.hidden = value !== 'ready'; });
    typeInputs().forEach((input) => {
      const selected = Boolean(chosenType && input.value === chosenType);
      input.checked = selected;
      input.dataset.currentChecked = String(selected);
    });
    main?.querySelectorAll('[data-vv-fixed-choice]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.vvFixedChoice === chosenType));
    });
    main?.querySelectorAll('[data-vv-case-option], [data-vv-fixed-type]').forEach((field) => {
      field.setAttribute('aria-busy', String(value === 'loading'));
    });
  }
  function showMessage(message) {
    const parent = main?.querySelector('[data-vv-case-option], [data-vv-fixed-type]');
    if (!parent) return;
    let error = parent.querySelector('.vv-case-message');
    if (!error) {
      error = document.createElement('p');
      error.className = 'vv-case-message';
      error.setAttribute('role', 'alert');
      parent.append(error);
    }
    error.hidden = !message;
    error.textContent = message || '';
  }
  function canSubmit(form) {
    if (form?.dataset.productId && form.dataset.productId !== currentId) return true;
    const expected = chosenType && desiredVariant();
    const id = form?.querySelector('input[name="id"]')?.value;
    if (state === 'ready' && expected?.available && (!id || id === String(expected.id))) return true;
    showMessage(!chosenType ? config.choose : state === 'loading' ? config.loading : config.retry);
    const field = main?.querySelector('[data-vv-case-option], [data-vv-fixed-type]');
    field?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    field?.querySelector('input, button')?.focus({ preventScroll: true });
    return false;
  }
  window.VelvoriaCaseSelection = { canSubmit, get chosenType() { return chosenType; }, get selectedLetter() { return letter(); } };
  function confirmSelection(resource) {
    clearTimeout(timer);
    if (!chosenType) {
      setState('pending');
      refreshColors();
      return;
    }
    const expected = desiredVariant();
    const forms = [...document.querySelectorAll(`product-form-component[data-product-id="${currentId}"]`)];
    const matches = expected && String(resource?.id) === String(expected.id) &&
      forms.every((form) => form.querySelector('input[name="id"]')?.value === String(expected.id));
    setState(matches && expected.available ? 'ready' : 'error');
    showMessage(matches ? expected.available ? '' : config.unavailable : config.retry);
    refreshColors();
  }
  function beginSelection() {
    clearTimeout(timer);
    setState(chosenType ? 'loading' : 'pending');
    showMessage('');
    timer = setTimeout(() => {
      if (state !== 'loading') return;
      setState('error');
      showMessage(config.retry);
    }, 20000);
  }
  document.addEventListener('change', (event) => {
    const target = event.target;
    const owner = target.closest?.('variant-picker');
    if (!owner || owner.dataset.productId !== currentId || !main?.contains(owner)) return;
    if (target.matches('[data-vv-case-type]')) chosenType = target.value;
    beginSelection();
    refreshColors();
  }, true);
  document.addEventListener('variant:update', (event) => {
    if (String(event.detail?.data?.productId) !== currentId) return;
    requestAnimationFrame(() => confirmSelection(event.detail.resource));
  });
  document.addEventListener('vv:variant:error', (event) => {
    if (event.target.dataset?.productId !== currentId) return;
    clearTimeout(timer);
    setState(chosenType ? 'error' : 'pending');
    showMessage(config.retry);
  });
  document.addEventListener('submit', (event) => {
    const form = event.target.closest?.('product-form-component[data-vv-case-required]');
    if (form && !canSubmit(form)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('click', (event) => {
    const fixed = event.target.closest?.('[data-vv-fixed-choice]');
    if (fixed && main?.contains(fixed)) {
      chosenType = fixed.dataset.vvFixedChoice;
      confirmSelection(desiredVariant());
      return;
    }
    const label = event.target.closest?.('[data-vv-case-option] label');
    if (label && state === 'error') {
      const input = label.querySelector('input');
      if (input) input.checked = false;
    }
    const buy = event.target.closest?.('button[type="submit"], sticky-add-to-cart button');
    if (!buy) return;
    const form = buy.closest('product-form-component[data-vv-case-required]');
    if (!form && !buy.closest('sticky-add-to-cart')) return;
    if (!canSubmit(form)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  function loadProduct(handle) {
    if (!products.has(handle)) {
      const root = window.Shopify?.routes?.root || '/';
      products.set(handle, fetch(`${root}products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin' })
        .then((response) => { if (!response.ok) throw new Error('Color unavailable'); return response.json(); })
        .catch(() => { products.delete(handle); return null; }));
    }
    return products.get(handle);
  }
  async function refreshColors() {
    const revision = ++colorRevision;
    const selectedLetter = letter();
    const selectedType = chosenType || 'Standart';
    const cards = [...(main?.querySelectorAll('[data-vv-color-handle]') || [])];
    await Promise.all(cards.map(async (card) => {
      const product = await loadProduct(card.dataset.vvColorHandle);
      if (!product || revision !== colorRevision) return;
      const wanted = product.variants.find((variant) => variant.option1 === selectedLetter && variant.option2 === selectedType);
      const variant = wanted || product.variants.find((item) => item.option1 === selectedLetter);
      if (!variant) return;
      const url = new URL(product.url || `/products/${product.handle}`, location.origin);
      url.searchParams.set('variant', variant.id);
      if (chosenType) url.searchParams.set('vv_type', chosenType);
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      card.href = url.toString();
      card.dataset.vvLetter = selectedLetter;
      const image = card.querySelector('img');
      const featured = variant.featured_image;
      const src = typeof featured === 'string' ? featured : featured?.src || featured?.url;
      if (image && src) {
        const imageUrl = new URL(src.startsWith('//') ? `https:${src}` : src, location.origin);
        imageUrl.searchParams.set('width', '180');
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = imageUrl.toString();
      }
    }));
  }
  document.addEventListener('click', async (event) => {
    const card = event.target.closest?.('[data-vv-color-handle]');
    if (!card || !main?.contains(card) || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    await refreshColors();
    location.assign(card.href);
  });
  setState('pending');
  if (chosenType) {
    const variant = desiredVariant();
    const form = main?.querySelector(`product-form-component[data-product-id="${currentId}"]`);
    if (variant && form?.querySelector('input[name="id"]')?.value === String(variant.id)) confirmSelection(variant);
    else chosenType = null;
  }
  refreshColors();
})();
